import util from 'util/common'

const state = {
  event_id: '',
  event_no: '',
  event_name: '',
  lecturer_name: '',
  event_date: '',
  event_date_public: '',
  event_date_public_multi: '',
  venue: {
    venue_name: '',
    homepage: '',
    zipcode: '',
    prefecture: '',
    city: '',
    address1: '',
    address2: ''
  },
  inquiry: {
    tel: '',
    email: ''
  },
  lecturer_url: '',
  description: '',
  fee: '',
  entry_url: '',
  parking: '',
  participant: '',
  sponsor: '',
  sponsor_name: '',
  images: [],
  end_date: '',
  published: '',
  status: '',
  event_kind: '',
  line_at: ''
}

const updateEventId = function (state, value) {
  state.event_id = value
}
const updateEventNo = function (state, value) {
  state.event_no = value
}
const updateEventName = function (state, value) {
  state.event_name = value
}
const updateLecturerName = function (state, value) {
  state.lecturer_name = value
}
const updateEventDate = function (state, value) {
  state.event_date = value
}
const updateEventDatePublic = function (state, value) {
  state.event_date_public = value
}
const updateEventDatePublicMulti = function (state, value) {
  if (util.isArray(value)) {
    state.event_date_public_multi = value.join(',')
  } else {
    state.event_date_public_multi = value
  }
}
const updateLecturerUrl = function (state, value) {
  state.lecturer_url = value
}
const updateDescription = function (state, value) {
  state.description = value
}
const updateFee = function (state, value) {
  state.fee = value
}
const updateEntryUrl = function (state, value) {
  state.entry_url = value
}
const updateParking = function (state, value) {
  state.parking = value
}
const updateParticipant = function (state, value) {
  state.participant = value
}
const updateSponsor = function (state, value) {
  state.sponsor = value
}
const updateSponsorName = function (state, value) {
  state.sponsor_name = value
}
const updateImages = function (state, value) {
  if (util.isArray(value)) {
    state.images = value
  } else {
    state.images[value.index] = value.data
  }
}
const updateEndDate = function (state, value) {
  state.end_date = value
}
const updateEndDatePublic = function (state, value) {
  state.end_date_public = value
}
const updatePublished = function (state, value) {
  state.published = value
}
const updateStatus = function (state, value) {
  state.status = value
}
const updateEventKind = function (state, value) {
  state.event_kind = value
}
const updateLineAt = function (state, value) {
  state.line_at = value
}
const updateEventForm = function (state, value) {
  updateEventId(state, value.event_id)
  updateEventNo(state, value.event_no)
  updateEventName(state, value.event_name)
  updateLecturerName(state, value.lecturer_name)
  updateEventDate(state, value.event_date)
  updateEventDatePublic(state, value.event_date_public)
  updateEventDatePublicMulti(state, value.event_date_public_multi)
  updateVenue(state, value.venue)
  updateInquiry(state, value.inquiry)
  updateLecturerUrl(state, value.lecturer_url)
  updateDescription(state, value.description)
  updateFee(state, value.fee)
  updateEntryUrl(state, value.entry_url)
  updateParking(state, value.parking)
  updateParticipant(state, value.participant)
  updateSponsor(state, value.sponsor)
  updateSponsorName(state, value.sponsor_name)
  updateEndDate(state, value.end_date)
  updateEndDatePublic(state, value.end_date_public)
  updatePublished(state, value.published)
  updateStatus(state, value.status)
  updateEventKind(state, value.event_kind)
  updateLineAt(state, value.line_at)
  updateImages(state,
    value.images || [value.image1, value.image2].filter(i => i !== ''))
}

const updateInquiry = function (state, value) {
  updateTel(state, value.tel)
  updateEmail(state, value.email)
}
const updateTel = function (state, value) {
  state.inquiry.tel = value
}
const updateEmail = function (state, value) {
  state.inquiry.email = value
}

const updateVenue = function (state, value) {
  updateVenueName(state, value.venue_name)
  updateHomepage(state, value.homepage)
  updateZipcode(state, value.zipcode)
  updatePrefecture(state, value.prefecture)
  updateCity(state, value.city)
  updateAddress1(state, value.address1)
  updateAddress2(state, value.address2)
}
const updateVenueName = function (state, value) {
  state.venue.venue_name = value
}
const updateHomepage = function (state, value) {
  state.venue.homepage = value
}
const updateZipcode = function (state, value) {
  state.venue.zipcode = value
}
const updatePrefecture = function (state, value) {
  state.venue.prefecture = value
}
const updateCity = function (state, value) {
  state.venue.city = value
}
const updateAddress1 = function (state, value) {
  state.venue.address1 = value
}
const updateAddress2 = function (state, value) {
  state.venue.address2 = value
}

const clearEventForm = function (state, value) {
  updateEventForm(state, {
    event_id: '',
    event_no: 0,
    event_name: '',
    lecturer_name: '',
    event_date: '',
    event_date_public: '',
    event_date_public_multi: '',
    venue: {
      venue_name: '',
      homepage: '',
      zipcode: '',
      prefecture: '',
      city: '',
      address1: '',
      address2: ''
    },
    inquiry: {
      tel: '',
      email: ''
    },
    lecturer_url: '',
    description: '',
    fee: '',
    entry_url: '',
    parking: '',
    participant: '',
    sponsor: '',
    sponsor_name: '',
    images: [],
    end_date: '',
    published: '',
    status: '',
    event_kind: ''
  })
}

const mutations = {
  updateEventForm,
  updateEventId,
  updateEventNo,
  updateEventName,
  updateLecturerName,
  updateEventDate,
  updateEventDatePublic,
  updateEventDatePublicMulti,
  updateLecturerUrl,
  updateDescription,
  updateFee,
  updateEntryUrl,
  updateParking,
  updateParticipant,
  updateSponsor,
  updateSponsorName,
  updateImages,
  updateEndDate,
  updatePublished,
  updateStatus,
  updateEventKind,
  updateLineAt,

  updateInquiry,
  updateTel,
  updateEmail,

  updateVenue,
  updateVenueName,
  updateHomepage,
  updateZipcode,
  updatePrefecture,
  updateCity,
  updateAddress1,
  updateAddress2,

  clearEventForm
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/event_form/store.js